import { PaletteOptions } from '@mui/material/styles';

/**
 * AquaRefine brand palette — restrained, low-chroma neutrals with a single
 * teal accent, color reserved for status. Transcribed 1:1 from the original
 * mockup's CSS custom properties so the refactor doesn't drift visually.
 */
export const aquaRefinePalette: PaletteOptions = {
  mode: 'light',
  primary: { main: '#0E7C86', dark: '#0A5F68', light: '#E3F2F0', contrastText: '#FFFFFF' },
  success: { main: '#1F8A5F', light: '#E3F5EC' },
  warning: { main: '#B9770E', light: '#FBF0DD' },
  error: { main: '#C0392B', light: '#FBE7E4' },
  info: { main: '#2563A6', light: '#E6F0FA' },
  background: { default: '#F4F7F6', paper: '#FFFFFF' },
  divider: '#DCE6E3',
  text: { primary: '#10201E', secondary: '#4F6864', disabled: '#7E958F' },
};

/** Not part of MuiPalette — pulled in via theme.ts `custom` augmentation for tokens MUI has no slot for. */
export const aquaRefineCustomTokens = {
  surfaceSunken: '#EDF3F1',
  surfaceHover: '#E4EEEC',
  borderStrong: '#C3D3CE',
  neutral: '#5B6B6E',
  neutralSoft: '#EBEFEE',
  chartRaw: '#AFD4D7',
  chartTrend: '#D65A45',
  chartGrid: '#E6ECEA',
  chartAxis: '#8FA39E',
};
